import React from "react";
import { View, TouchableOpacity } from "react-native";
import Text from "@/components/shared/AppText";
import AppTitle from "@/components/shared/AppTitle";
import Bullet from "@/components/shared/Bullet";
import { Ionicons } from "@expo/vector-icons";
import tw from "twrnc";
import { brandColor } from "@/components/globalStyle";
import { useNavigation } from "@react-navigation/native";
import { t } from "@/localization";

const PurchaseSuccess = ({ event, route }) => {
  const navigation = useNavigation();
  const eventSlug = event?.slug || route?.params?.slug || null;
  const purchaseType = route?.params?.purchaseType;
  const isCreditPurchase = purchaseType === "credits" && !eventSlug;

  const title = isCreditPurchase
    ? t("Credits Added Successfully")
    : t("Thank You for Your Purchase!");
  const intro = isCreditPurchase
    ? t("Your credits are ready to use. You can now:")
    : t("You can now:");
  const bullets = isCreditPurchase
    ? [
        t("Use your credits to unlock more events"),
        t("Check your available balance before your next purchase"),
        t("Return to your events and keep editing"),
      ]
    : [
        t(
          "Invite guests to your event by sharing the event link or using the Guest List feature"
        ),
        t('Open "How to Go Live" for a step-by-step guide'),
        t("Go live on the day of your event"),
      ];

  return (
    <View style={tw`flex-col mx-11 px-4 max-w-[600px] w-full self-center`}>
      <View style={tw`items-center mb-8`}>
        <Ionicons name="checkmark-circle" size={80} color="#22C55E" />
      </View>

      <AppTitle text={title} style={tw`text-center mb-5`} />

      <Text style={tw`text-base mb-6 text-center`}>{intro}</Text>

      <View style={tw`mb-8`}>
        {bullets.map((bullet) => (
          <Bullet key={bullet}>
            <Text>{bullet}</Text>
          </Bullet>
        ))}
      </View>

      <TouchableOpacity
        style={[
          tw`h-12 rounded-lg items-center justify-center`,
          { backgroundColor: brandColor },
        ]}
        onPress={() => {
          if (eventSlug && navigation.canGoBack()) {
            navigation.goBack();
          } else if (eventSlug) {
            navigation.navigate("EventEdit", { slug: eventSlug });
          } else {
            navigation.navigate("EventList");
          }
        }}
      >
        <Text style={tw`text-white text-base font-medium`}>
          {eventSlug ? t("Return to Event") : t("View My Events")}
        </Text>
      </TouchableOpacity>
    </View>
  );
};

export default PurchaseSuccess;
